module.exports = __webpack_public_path__ + "img/settings_edit_beacon_location_changes_made.468d8db7.png";